import {combineReducers} from 'redux';
import count from './reducer-count';
import modal from './reducer-collaborate';

export default combineReducers({
    count,
    modal
});


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/reducer.js